import { useGoogleLogin } from "@react-oauth/google";
import { useLocation, useNavigate } from "react-router-dom";
import { showToastError, showToastSuccess } from "../../services/Toasts/toasts";
import { logWithGoogle } from "../../services/Api/loginService";
import { initSocket } from "../../services/Utils/socketIo";
import { useTokenContext } from "../../context/tokenContext";
import { redirection } from "../../services/Utils/functionService";
import google from "../../assets/logos/google.png";
import { createAccountWithGoogle } from "../../services/Api/userService";

const GoogleLoginButton = () => {
  // Context
  const { refreshUserData } = useTokenContext();
  const { setUtc, setUtp, setIsAdmin, setIsSuperAdmin, setFirstname } =
    useTokenContext();
  // Hooks
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");

  const loginErrror = () => {
    showToastError("Une erreur est survenue lors de la connexion.");
  };

  // Hook Google Login pour la création de compte
  const singInWithGoogle = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      if (!token) {
        showToastError("Token d'invitation manquant. Vérifiez votre lien d'invitation.");
        return;
      }

      try {
        await createAccountWithGoogle(tokenResponse.access_token, token);
        showToastSuccess("Votre compte a bien été créé.");
        navigate("/");
      } catch (error: any) {
        if (error?.response?.status === 500) {
          if (error?.response?.data === "email account not match") {
            showToastError(
              "Merci de vous connecter avec l'email de l'invitation."
            );
          } else {
            showToastError("Une erreur est survenue lors de la connexion.");
          }
        } else if (error?.response?.status === 400) {
          showToastError("Les informations fournies sont invalides.");
        } else {
          showToastError("Une erreur est survenue lors de la connexion.");
        }
      }
    },
    onError: loginErrror,
  });

  // Hook Google Login pour la connexion normale
  const loginWithGoogle = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        // Selon ton backend, adapte ici : access_token ou id_token
        const response = await logWithGoogle(tokenResponse.access_token);
        // Attendre que refreshUserData soit terminé avant de rediriger
        await refreshUserData();
        initSocket(response?.data?.id);

        redirection(location, navigate, response?.data?.isSuperAdmin);
      } catch (error: any) {
        if (
          error.message &&
          typeof error.message === "string" &&
          error.message.trim() === "User not invited"
        ) {
          setUtc(0);
          setUtp(0);
          setIsAdmin(0);
          setIsSuperAdmin(0);
          setFirstname("");
          showToastError("Vous n'avez pas été invité a rejoindre Nexum.");
        } else if (
          error.message &&
          typeof error.message === "string" &&
          error.message.trim() === "User exist but account not linked"
        ) {
          showToastError(
            "Vous devez lier votre compte Google à votre compte Nexum."
          );
        } else {
          showToastError("Une erreur est survenue lors de la connexion.");
        }
      }
    },
    onError: () => {
      showToastError("Une erreur est survenue lors de la connexion.");
    },
  });
      
  return (
    <button
      type="button"
      className="w-full h-12 cursor-pointer bg-white border-2 border-gray-200 text-gray-700 font-medium rounded-xl shadow-sm hover:shadow-md hover:border-red-300 hover:bg-red-50 transition-all duration-300 flex items-center justify-center space-x-3 group"
      onClick={() => {if(location.pathname.includes("createaccount")) {singInWithGoogle()} else {loginWithGoogle()}}}
    >
      <img
        src={google}
        alt="logo Google"
        className="h-5 w-5 transition-transform duration-300 group-hover:scale-110"
      />
      <span>Se connecter avec Google</span>
    </button>
  );
};

export default GoogleLoginButton